export default __webpack_public_path__ + "static/media/p13.081f9139.jpg";